import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { FadeUp } from "./Reveal";
import { SERVICES } from "@/data";

export default function Services() {
  return (
    <section id="services" className="py-24 lg:py-40 bg-[#0A0A0A]" data-testid="services">
      <div className="mx-auto max-w-[1600px] px-6 lg:px-12">
        <FadeUp className="mb-16 lg:mb-24 flex flex-col lg:flex-row lg:items-end justify-between gap-8">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <span className="w-8 h-px bg-[#FF4D00]" aria-hidden="true" />
              <span className="font-mono text-xs uppercase tracking-[0.25em] text-[#FF4D00]">Capabilities</span>
            </div>
            <h2 className="font-display font-bold uppercase tracking-tighter text-white text-4xl sm:text-5xl lg:text-7xl leading-[0.9]">
              What We<br />Put Up
            </h2>
          </div>
          <p className="font-mono font-light text-[#A3A3A3] max-w-sm text-base">
            Six disciplines, one standard. From single-lift access to full industrial
            shutdowns — we scope, design and erect the temporary works that make
            permanent work possible.
          </p>
        </FadeUp>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4">
          {SERVICES.map((s, i) => (
            <FadeUp
              key={s.index}
              delay={i * 0.05}
              className={`${s.span} group relative border border-[#333] bg-[#111] overflow-hidden min-h-[280px] flex flex-col justify-between p-8 lg:p-10`}
              data-testid={`service-card-${s.index}`}
            >
              {s.image && (
                <div className="absolute inset-0 z-0">
                  <img
                    src={s.image}
                    alt={s.title}
                    className="w-full h-full object-cover opacity-25 group-hover:opacity-40 group-hover:scale-105 transition-all duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] to-transparent" />
                </div>
              )}
              <div className="relative z-10 flex items-start justify-between">
                <span className="font-mono text-xs uppercase tracking-[0.2em] text-[#A3A3A3]">Service</span>
                <span className="font-display font-black text-3xl text-[#FF4D00]" aria-hidden="true">
                  [{s.index}]
                </span>
              </div>
              <div className="relative z-10 mt-16">
                <h3 className="font-display font-bold uppercase tracking-tight text-white text-2xl lg:text-3xl mb-3 group-hover:text-[#FF4D00] transition-colors">
                  {s.title}
                </h3>
                <p className="font-mono font-light text-[#A3A3A3] text-sm max-w-md leading-relaxed">{s.desc}</p>
                <span className="mt-5 inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-[#FF4D00] opacity-70 group-hover:opacity-100 transition-opacity">
                  View Service <ArrowUpRight size={14} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                </span>
              </div>
              <Link
                to={`/services/${s.slug}`}
                className="absolute inset-0 z-20"
                aria-label={`${s.title} — view service`}
                data-testid={`service-link-${s.slug}`}
              />
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
